import type { FaireProductEntity } from "../../entity_types/product";

export const p_eqc69ads6t: FaireProductEntity = {
  token: "p_eqc69ads6t",
  type: "product",
  name: "Muscle Balm – Beeswax Blend – Menthol – Essential Oils",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/f7f9ab69e51d333f1059eb7bc25888d181d1662065d5203b3be073d609b7ea65.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.01,
  description:
    "Soothe sore muscles and aching joints naturally with our all-natural Muscle Massage Balm. Crafted with a nourishing beeswax blend, organic oils, and pure essential oils, this balm combines cooling menthol crystals and warming botanicals for deep, penetrating relief. Perfect for post-workout recovery, massages, and everyday aches.\n\nProduct Details\n\n-Cooling menthol for instant relief\n-Warming essential oils for muscle therapy\n-Ingredients: Sunflower Oil*, Beeswax, Menthol Crystals, Safflower Oil*, Sesame Oil*, Coconut Oil*, Essential Oils of Cajeput*, Camphor*, Peppermint*, Cinnamon Leaf*, Clove Bud* (*certified organic)\n-Clean, non-toxic formula\n\nIdeal For: Wellness shops, spa gift sets, yoga studios, and natural health retailers.\n\nLearn more at BigDipperWaxWorks.com.",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:55.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
